import { faCalendarAlt, faClockFour } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function ScheduledInterviewCard({ scheduledInterview, onJoinHMSClick }) {
  return (
    <div
      className="dashboard-calender-event d-flex cursor-pointer bg-grey-4 border rounded p-2 mt-3 fs-smallest"
      onClick={() =>
        onJoinHMSClick(
          scheduledInterview?.event,
          scheduledInterview?.hms_room_id
        )
      }
    >
      <div className="flex-grow-1">
        <div className="text-grey-4 align-items-center d-flex flex-wrap  mb-1 time">
          <span className="mr-4">
            <FontAwesomeIcon icon={faClockFour} className="mr-2" />
            <span>
              {scheduledInterview?.in_user_timezone && scheduledInterview.in_user_timezone?.start_time && scheduledInterview.in_user_timezone.start_time.slice(0 ,5)} -{" "}
              <span>{scheduledInterview?.in_user_timezone && scheduledInterview.in_user_timezone?.end_time && scheduledInterview.in_user_timezone?.end_time.slice(0 , 5)}</span>{" "}
              <span>{scheduledInterview?.in_user_timezone && scheduledInterview.in_user_timezone?.timezone}</span>
            </span>
          </span>
          <span>
            <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
            <span>{scheduledInterview?.interview_date}</span>
          </span>
        </div>
        <span className="text-capitalize">
          {scheduledInterview?.event_details?.title}
        </span>{" "}
        <span className="text-grey-4">with</span>{" "}
        <span className="text-capitalize">
          {scheduledInterview?.event_details?.event_creator.full_name}
        </span>{" "}
        <span className="text-grey-4">for</span>{" "}
        {scheduledInterview?.job_details?.title}.
      </div>
      <span>
        <img src="/assets/images/vid-share-screen.svg" alt="vid-share-icon" />
      </span>
    </div>
  );
}

export default ScheduledInterviewCard;
